import { X } from 'lucide-react';

const dayNames = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

export function ReplaceMealConfirmDrawer({
  isOpen,
  onClose,
  onConfirm,
  existingMealName,
  newMealName,
  day,
  mealType,
}) {
  if (!isOpen) return null;

  const fullDayName = dayNames[day] || day;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="fixed inset-x-0 bottom-0 bg-card text-foreground rounded-t-3xl z-50 max-w-md mx-auto animate-slide-up">
        {/* Handle bar */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-10 h-1 bg-muted rounded-full" />
        </div>

        <div className="px-6 pb-8">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl">Replace Meal?</h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full hover:bg-muted flex items-center justify-center transition-colors"
            >
              <X className="w-5 h-5 text-muted-foreground" />
            </button>
          </div>

          {/* Message */}
          <div className="mb-6">
            <p className="text-muted-foreground mb-4">
              You already have <span className="font-medium text-foreground">{existingMealName}</span> planned for {mealType.toLowerCase()} on {fullDayName}.
            </p>
            <p className="text-muted-foreground">
              Do you want to replace it with <span className="font-medium text-foreground">{newMealName}</span>?
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={onConfirm}
              className="w-full py-3 bg-primary text-primary-foreground rounded-full hover:bg-primary-hover transition-colors"
            >
              Replace Meal
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 border-2 border-[var(--primary)] text-[var(--primary-foreground)] rounded-full hover:bg-[var(--primary-light)] transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
